/* eslint-disable */
import {NavigationBlock} from './NavigationBlock';
/**
* @description Interface for Avensia.Commerce.Web.src.components.MainMenu.themes.BGH_RD3.mobile.contact.ContactNavigationBlock
*/
export interface ContactNavigationBlock extends NavigationBlock {
	
}
export const isContactNavigationBlock = (model: unknown): model is ContactNavigationBlock => (model as ContactNavigationBlock).component === 'Bygghemma.Commerce.Web.src.components.MainMenu.themes.BGH_RD3.mobile.contact.ContactNavigationBlock';

